import { Grid, Typography } from "@mui/material";
import SuscrPickOrg from "../../components/Profile/SuscrPickOrg";
import { Spinner } from "../../components/Loading/Spinner";
import { useSuperAdminUsers } from "../../context/SuperAdmin/UsersContext";
import UsersPanel from "../../components/Table/Users/UsersPanel";
import { useAuthContext } from "../../hooks/Auth";

function UsersPage() {
  const { organizaciones, selectedOrg, handleSelectChange, isLoadingOrgs } =
    useSuperAdminUsers();

  const { canAccess } = useAuthContext();
  const isSuperAdmin = canAccess("view:plans");

  return (
    <Grid
      container
      spacing={4}
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        pt: 3,
      }}
    >
      {/* Título */}
      <Grid item>
        <Typography variant={"h4"} sx={{ color: "#005559", fontSize: "30px" }}>
          <b>Cuentas Administradas</b> | Usuarios
        </Typography>
      </Grid>

      {isLoadingOrgs ? (
        <Grid item>
          <Spinner msg="Cargando por favor espere..." />
        </Grid>
      ) : (
        <>
          {/* Seleccionar organizacion */}
          {isSuperAdmin && (
            <Grid item>
              <SuscrPickOrg
                organizaciones={organizaciones}
                selectedOrg={selectedOrg ? selectedOrg : ""}
                handleChange={handleSelectChange}
                isLoading={isLoadingOrgs}
              />
            </Grid>
          )}

          {/* Menú de usuarios */}
          {selectedOrg && <UsersPanel />}
        </>
      )}
    </Grid>
  );
}

export default UsersPage;
